var map = {
	"./how-to-become-better-with-ui-design.md": [
		31,
		31
	],
	"./the-truth-about-design.md": [
		5279,
		279
	],
	"./the-ugly-truth-about-design.md": [
		1377,
		377
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1927;
module.exports = webpackAsyncContext;